import React from 'react';
import { Box, Typography } from '@material-ui/core';

// Faixa DIDÁTICA — mostra um fluxo de peças ligadas por setas com etiquetas,
// para o operador perceber o que está a fazer em cada ecrã. Tema laranja/âmbar
// (Material Dashboard 2). Reutilizável em todas as páginas de CRUD.
//
//   <AdminHint
//     nodes={[{text:'Grupo',tone:'slate'},{text:'Organização',tone:'green'},{text:'Perfil',tone:'indigo'}]}
//     labels={['agrega','aponta para · partilhável']}
//     note="Aqui geres as Organizações…" />
// Tons SUAVES — tag com fundo levemente tingido + texto na cor (sem gradientes fortes).
const TONES = {
  slate:  { bg: '#eef0f3', fg: '#5b6472', bd: '#e3e6ea' },
  green:  { bg: '#e9f7ec', fg: '#2e7d32', bd: '#cdeed4' },
  indigo: { bg: '#eeeefc', fg: '#4338ca', bd: '#dcdcfa' },
  teal:   { bg: '#e6f7f6', fg: '#0d7a72', bd: '#c8eeeb' },
  orange: { bg: '#fff1e3', fg: '#c2410c', bd: '#fdd9bd' },
  violet: { bg: '#f3effd', fg: '#7c3aed', bd: '#e5dcfb' },
};

export default function AdminHint({ nodes = [], labels = [], note }) {
  return (
    <Box style={{
      background: 'var(--adm-brand-soft, #eef5f1)', border: '1px solid #d8e9e1', borderRadius: 14,
      padding: '14px 18px', marginBottom: 22,
    }}>
      <Box style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
        {nodes.map((n, i) => {
          const t = TONES[n.tone] || TONES.orange;
          return (
            <React.Fragment key={i}>
              <span style={{
                background: t.bg, color: t.fg, border: `1px solid ${t.bd}`,
                fontSize: '0.78rem', fontWeight: 700, padding: '5px 12px', borderRadius: 8, whiteSpace: 'nowrap',
              }}>{n.text}</span>
              {i < nodes.length - 1 && (
                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 4px' }}>
                  {labels[i] && <Typography style={{ fontSize: '0.6rem', fontWeight: 700, color: 'var(--adm-brand-mid, #5a8577)', lineHeight: 1.1, marginBottom: 1, whiteSpace: 'nowrap' }}>{labels[i]}</Typography>}
                  <span style={{ color: 'var(--adm-brand, #2f5d50)', fontSize: 17, fontWeight: 800, lineHeight: 1 }}>→</span>
                </Box>
              )}
            </React.Fragment>
          );
        })}
      </Box>
      {note && (
        <Typography style={{ fontSize: '0.78rem', color: '#3f6b5c', fontWeight: 500, lineHeight: 1.5, marginTop: 10 }}>
          🔎 {note}
        </Typography>
      )}
    </Box>
  );
}
